export const TOGGLE_ALERT_ARCHIVE_DESIGN = 'TOGGLE_ALERT_ARCHIVE_DESIGN';
export const RESET_ALERT_ARCHIVE_DESIGN = 'RESET_ALERT_ARCHIVE_DESIGN';
export const UPDATE_ARCHIVE_DESIGN_INFO = 'UPDATE_ARCHIVE_DESIGN_INFO';

export const TOGGLE_ALERT_ARCHIVE_MENU = 'TOGGLE_ALERT_ARCHIVE_MENU';
export const RESET_ALERT_ARCHIVE_MENU = 'RESET_ALERT_ARCHIVE_MENU';
export const UPDATE_ARCHIVE_MENU_INFO = 'UPDATE_ARCHIVE_MENU_INFO';

export const TOGGLE_ALERT_DOWNLOADING = 'TOGGLE_ALERT_DOWNLOADING';
export const RESET_ALERT_DOWNLOADING = 'RESET_ALERT_DOWNLOADING';
export const UPDATE_DOWNLOADING_INFO = 'UPDATE_DOWNLOADING_INFO';
export const UPDATE_DOWNLOADING_COMPLETE = 'UPDATE_DOWNLOADING_COMPLETE';

export const TOGGLE_ALERT_COMMON_ERROR = 'TOGGLE_ALERT_COMMON_ERROR';
export const RESET_ALERT_COMMON_ERROR = 'RESET_ALERT_COMMON_ERROR';
export const UPDATE_COMMON_ERROR_INFO = 'UPDATE_COMMON_ERROR_INFO';

export function toggleArchiveDesignAlert() {
  return {
    type: TOGGLE_ALERT_ARCHIVE_DESIGN,
  };
}

export function resetArchiveDesignAlert() {
  return {
    type: RESET_ALERT_ARCHIVE_DESIGN,
  };
}

export function updateArchiveDesignInfo(designId, designName) {
  return {
    designId,
    designName,
    type: UPDATE_ARCHIVE_DESIGN_INFO,
  };
}

export function toggleArchiveMenuAlert() {
  return {
    type: TOGGLE_ALERT_ARCHIVE_MENU,
  };
}

export function resetArchiveMenuAlert() {
  return {
    type: RESET_ALERT_ARCHIVE_MENU,
  };
}

export function updateArchiveMenuInfo(menuId, menuName) {
  return {
    menuId,
    menuName,
    type: UPDATE_ARCHIVE_MENU_INFO,
  };
}

export function toggleAlertDownloading() {
  return {
    type: TOGGLE_ALERT_DOWNLOADING,
  };
}

export function resetAlertDownloading() {
  return {
    type: RESET_ALERT_DOWNLOADING,
  };
}

export function updateDownloadingInfo(fileName) {
  return {
    fileName,
    type: UPDATE_DOWNLOADING_INFO,
  };
}

export function updateDownloadingComplete() {
  return {
    type: UPDATE_DOWNLOADING_COMPLETE,
  };
}

export function toggleAlertCommonError() {
  return {
    type: TOGGLE_ALERT_COMMON_ERROR,
  };
}

export function resetAlertCommonError() {
  return {
    type: RESET_ALERT_COMMON_ERROR,
  };
}

export function updateCommonErrorInfo(errorMessage) {
  return {
    errorMessage,
    type: UPDATE_COMMON_ERROR_INFO,
  };
}
